import React from 'react';
import { ChevronRight } from 'lucide-react';
import './FilterSelect.css';

interface FilterOption {
  value: string;
  label: string;
  icon: React.ElementType;
}

interface FilterSelectProps {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onSelect: (value: string) => void;
  value: string;
  options: FilterOption[];
  icon: React.ElementType;
  allLabel: string;
  disabled?: boolean;
  disabledLabel?: string;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
  isOpen,
  onToggle,
  onSelect,
  value,
  options,
  icon: Icon,
  allLabel,
  disabled = false,
  disabledLabel = 'NO_DISPONIBLE',
}) => {
  return (
    <div className="filter-select-wrapper" data-keep-detail>
      <button
        type="button"
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          if (disabled) return;
          onToggle(!isOpen);
        }}
        className={`filter-select-btn ${isOpen ? "active" : ""} ${disabled ? "filter-select-btn-error" : ""}`}
        title={disabled ? disabledLabel : undefined}
      >
        <Icon size={12} className="filter-select-icon" />
        <span className="filter-select-text">
          {disabled ? disabledLabel : (value === 'all' ? allLabel : value.toUpperCase())}
        </span>
        <ChevronRight size={10} className={`filter-select-arrow ${isOpen ? "open" : ""}`} />
      </button>

      {isOpen && !disabled && (
        <div className="filter-select-menu">
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => { onSelect(opt.value); onToggle(false); }}
              className={`filter-select-item ${value === opt.value ? "active" : ""}`}
            >
              <opt.icon size={12} className="filter-select-item-icon" />
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
